import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { Provider } from "react-redux";
import { appPersistor, appStore } from "./Redux/store";
import { BrowserRouter } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import "./Components/Languages/Langs/i18next";
import { LanguageContextProvider } from "./Components/Languages/Langs/LanguageContext";
import { registerServiceWorker } from "./serviceWorkerRegistration";
import { DisableScreenshot } from "./Components/secure/DisableModeSecureContent";
import { DisableMode } from "./Components/secure/DevelperModeDisable";

const root = ReactDOM.createRoot(document.getElementById("app") as HTMLElement);

registerServiceWorker();

root.render(
  <StrictMode>
    <Provider store={appStore}>
      <PersistGate loading={null} persistor={appPersistor}>
        <BrowserRouter basename="/">
          <LanguageContextProvider>
            <App />
            <DisableMode />
            <DisableScreenshot />
          </LanguageContextProvider>
        </BrowserRouter>
      </PersistGate>
    </Provider>
  </StrictMode>,
);
